import React, { useEffect } from "react";
import { connect } from "react-redux";
import { saveUser } from "../../redux/actions/userAction";
import { saveProducts } from "../../redux/actions/productsAction";
import ImageMapper from "react-img-mapper";
import { useHistory } from "react-router-dom";
import HeroSliderOneNew from "../../backconfig/banner/HeroSliderOneNew";
import BannerClassicScroll from "./BannerClassicScroll";
import { useState } from "react";
import BannerAmazonStyle from "./BannerAmazonStyle";
import YouTubeBackground from "../../backconfig/homepage/YouTubeBackground";
import ProductgridList from "../../wrappers/product/ProductgridList";
import ShopProducts from "../../wrappers/product/ShopProducts";
import HomeCarousel from "./HomeCarousel";
import { Link } from "react-router-dom";

const GridRenderer = ({ grids, products }) => {
  console.log(products);
  return (
    <div className="space-y-4">
      {grids?.map((grid, index) => {
        // Creiamo le colonne dinamiche basandoci su width
        const gridTemplate = grid.cells
          .map((cell) => `${cell.width}%`)
          .join(" ");

        return (
          <div
            key={index}
            className="grid gap-4 flex flex-col"
            style={{
              gridTemplateColumns: gridTemplate,
            }}
          >
            {grid.cells.map((cell, i) => (
              <RenderCell key={i} cell={cell} products={products} />
            ))}
          </div>
        );
      })}
    </div>
  );
};

const RenderCell = ({ cell, products }) => {
  const { type, width } = cell;
  console.log(cell);
  switch (type) {
    case "image":
      return <ImageComponent url={cell.url} link={cell.link} width={width} />;
    case "carousel":
      return (
        <CarouselComponent
          bannerIndex={cell.bannerIndex}
          banner={cell.banner}
          width={width}
        />
      );
    case "articolo":
      return (
        <ArticoloComponent id={cell.id} width={width} products={products} />
      );
    case "video":
      return <YouTubeBackground videoId={cell.url} widthPercent={width} />;
    case "button":
      return (
        <ButtonComponent
          width={width}
          content={cell.content}
          link={cell.link}
        />
      );
    case "text":
      return <TextComponent width={width} content={cell.content} />;
    default:
      return null;
  }
};

const ImageComponent = ({ url, link, width }) => {
  console.log(url, link, width);
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{ width: `${width}%` }}
      className="block"
    >
      <img
        src={url}
        alt="Immagine"
        className="w-full object-cover rounded-lg"
        style={{ maxHeight: "400px" }}
      />
    </a>
  );
};
const ButtonComponent = ({ url, link, width, content }) => {
  console.log(url, link, width);
  return (
    <Link
      to={process.env.PUBLIC_URL + link}
      rel="noopener noreferrer"
      style={{
        width: `${width}%`,
        padding: "10px 20px",
        backgroundColor: "#dedede",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
        zIndex: 10,
        textAlign: "center",
      }}
      className="block"
    >
      <p style={{ maxHeight: "400px" }}>{content}</p>
    </Link>
  );
};
const TextComponent = ({ url, link, width, content }) => {
  console.log(url, link, width);
  return (
    <div
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        padding: "10px 20px",
        width: `${width}%`,
        textAlign: "center",
      }}
      className="block"
    >
      <p style={{ maxHeight: "400px", fontSize: "xx-large" }}>{content}</p>
    </div>
  );
};
const CarouselComponent = ({ bannerIndex, banner, width }) => (
  <div style={{ width: `${width}%` }} className="p-4 text-center">
    <HomeCarousel bannerIndex={bannerIndex} banner={banner} />
  </div>
);

const ArticoloComponent = ({ id, width, products }) => {
  const prod = products?.filter((product) => product.id == id);
  console.log(id, prod, products);
  return (
    <div
      style={{ width: `${width}%` }}
      className="p-4 bg-blue-200 rounded-lg shadow text-center"
    >
      {prod ? (
        <ShopProducts
          isLoggedUser={false}
          visualizzaPrezzi={false}
          layout={"grid one-column"}
          products={prod}
          oneProduct={true}
        />
      ) : null}
    </div>
  );
};

const VideoComponent = ({ url, width }) => (
  <div style={{ width: `${width}%` }} className="relative aspect-video">
    <iframe
      className="w-full h-full rounded-lg"
      src={`https://www.youtube.com/embed/${url}`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>
);

const HomePageDGA = (props) => {
  const history = useHistory();
  const { userData, bannerProps, forTestOnly, products } = props;
  const isLoggedUser =
    userData?.user?.user &&
    (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge)
      ? true
      : false;

  const [homePageNow, setHomePageNow] = useState(
    forTestOnly
      ? bannerProps
      : bannerProps ||
          (isLoggedUser ? window["homepage"] : window["homepageNoLog"])
  );

  useEffect(() => {
    setHomePageNow(
      forTestOnly
        ? bannerProps
        : bannerProps ||
            (isLoggedUser ? window["homepage"] : window["homepageNoLog"])
    );
  }, [forTestOnly, bannerProps, isLoggedUser]);
  useEffect(() => {
    console.log(products);
  }, [products]);
  return (
    <div className={`single-slider bg-white `}>
      <div className="container" style={{ maxWidth: "80%" }}>
        <div className="row">
          <GridRenderer grids={homePageNow} products={products} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    products: state.productData.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
    saveProducts: (products, addToast) => {
      dispatch(saveProducts(products, addToast));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomePageDGA);
